import { render, staticRenderFns } from "./Rotation.vue?vue&type=template&id=7fc72868&scoped=true&lang=html"
import script from "./Rotation.vue?vue&type=script&lang=js"
export * from "./Rotation.vue?vue&type=script&lang=js"
import style0 from "./Rotation.vue?vue&type=style&index=0&id=7fc72868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc72868",
  null
  
)

export default component.exports